<div class="absolute top-0 right-0 bottom-0 left-0 bg-gray-500 bg-opacity-40 rounded-sm flex items-center justify-center animate-fadein z-20">
  <div class="bg-white dark:bg-dark-card rounded-sm text-sm w-auto px-4 py-3 flex gap-2 items-center">
        <span class="text-theme-primary animate-pulse">
          <lucide-angular [name]="Loader" [size]="16"></lucide-angular>
        </span>{{ 'common.loading' | translate }}
  </div>
</div>
